import * as React from 'react'
import {Badge, Box, Link, Typography} from "@mui/material";
import {IconSeeker, TooltipSeeker} from "@ui-seeker/core";
import {formatPriceSymbol} from "@ui-seeker/utils";

import { NotAllowedBlock } from "@components";
import { useBuildExternalURL } from "@hooks"


export default function sitePriceColumn(name, label) {
    return {
        name, label,
        options: {
            filter: false,
            headerAlign: 'left',
            customBodyRowRenderLite: (value, { skuID }) => {
                const { productURL } = useBuildExternalURL({ siteData: { siteID: value.siteID, productID: value.minProductID } })
                return <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Typography component="span" fontWeight="bold" variant="body2" sx={{ mr: 1 }}>List Price:</Typography>
                    {!!value.listPrice && <Typography variant="body2" sx={{ color: 'text.disabled', textDecoration: 'line-through', fontSize: '0.75rem' }}>
                        {formatPriceSymbol(value.listPrice, value.currency)}
                    </Typography>}
                    {!value.listPrice && <NotAllowedBlock />}
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Typography component="span" fontWeight="bold" variant="body2" sx={{ mr: 1 }}>Actual Price:</Typography>
                    {!!value.price && <Typography variant="body2">
                        {formatPriceSymbol(value.price, value.currency)}
                    </Typography>}
                    {!!value.price && <TooltipSeeker title={value.stock ? 'In Stock' : 'Out of Stock'}>
                        <Badge
                            color={value.stock ? 'success' : 'error'}
                            badgeContent=""
                            sx={{ ml: 2 }}
                        />
                    </TooltipSeeker>}
                    {!value.price && <NotAllowedBlock />}
                </Box>

                <Box sx={{ whiteSpace: "normal", wordWrap: "break-word", display: "inline-block", verticalAlign: "middle"}}>
                    <Link
                        href={productURL}
                        target="_blank"
                        sx={{
                            cursor: "pointer",
                            color: 'text.primary',
                            '&:hover': { textDecoration: 'none' },
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        Go to Product
                        <IconSeeker icon="up-right-from-square" sx={{ color: 'primary.main' }} />
                    </Link>
                </Box>
            </Box>
            }
        }
    }
}